export enum ThemeSids {
  aba = 'aba',
  abatest = 'abatest',
  jig = 'jig',
  talentpool = 'talentpool',
  edunet = 'edunet',
  wconat = 'wconat',
  ncph = 'ncph',
  t4a = 't4a',
  abaooe = 'abaooe',
  amseu = 'amseu',
}

export interface ThemeSite {
  domain?: string
  sid: ThemeSids
  color: string
  title?: any
  language?: string
  languageDropdown: boolean
}
